



import {Component, Vue, Prop} from 'vue-property-decorator';
import SvgRender from "@/components/Atoms/SvgRender/SvgRender.vue";

@Component({
  components: {SvgRender}
})
export default class MenuItem extends Vue {
  @Prop({required: true, type: String, default: ''}) name!: string
  @Prop(String) icon?: string

  private handleClickItem(): void {
    this.$emit('click')
  }
}
